// extracted by mini-css-extract-plugin
export default {"product_list_container":"ProductList_product_list_container__ZsKD4"};